import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import Iconify from "../../../components/iconify";
import { ProductCategory } from "../../../@types/product";
import { Brands } from "../../../@types/brand.type";
import { Suppliers } from "../../../@types/supplier.type";

type Props = {
  filterName: string;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filterBrandId: string;
  onFilterBrandId: (event: SelectChangeEvent<string>) => void;
  filterCategory: string;
  onFilterCategory: (event: SelectChangeEvent<string>) => void;
  filterSupplierId: string;
  onFilterSupplierId: (event: SelectChangeEvent<string>) => void;
  onResetFilter: VoidFunction;
  brands: Brands[];
  suppliers: Suppliers[];
};

export default function ProductTableToolbar({
  filterName,
  onFilterName,
  filterBrandId,
  onFilterBrandId,
  filterCategory,
  onFilterCategory,
  filterSupplierId,
  onFilterSupplierId,
  onResetFilter,
  brands,
  suppliers,
}: Props) {
  const formatEnumText = (text?: string) => {
    if (!text) return "";
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const categoryOptions = Object.values(ProductCategory);

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: "column",
        md: "row",
      }}
      sx={{ px: 2.5, py: 3 }}>
      <TextField
        fullWidth
        value={filterName}
        onChange={onFilterName}
        placeholder="Search Product By Name"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: "text.disabled" }} />
            </InputAdornment>
          ),
        }}
      />

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Brand</InputLabel>
        <Select
          value={filterBrandId}
          label="Brand"
          onChange={onFilterBrandId}
        >
          <MenuItem value="">All</MenuItem>
          {brands.map((b) => (
            <MenuItem key={b.id} value={String(b.id)}>
              {b.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 220 }}>
        <InputLabel>Category</InputLabel>
        <Select
          value={filterCategory}
          label="Category"
          onChange={onFilterCategory}
        >
          <MenuItem value="">All</MenuItem>
          {categoryOptions.map((c) => (
            <MenuItem key={c} value={c}>
              {formatEnumText(String(c))}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 220 }}>
        <InputLabel>Supplier</InputLabel>
        <Select
          value={filterSupplierId}
          label="Supplier"
          onChange={onFilterSupplierId}
        >
          <MenuItem value="">All</MenuItem>
          {suppliers.map((s) => (
            <MenuItem key={s.id} value={String(s.id)}>
              {s.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button color="error" onClick={onResetFilter}>Cancel</Button>
    </Stack>
  );
}
